<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.table && wrapper">
    <div class="banner center" style="max-width:1200px;">
        <div class="row row_header">
            <div class="col-5">
                {{localService.languageContent.table.name}}
            </div>
            <div class="col-3">
                {{localService.languageContent.table.contact_num}}
            </div>
            <div class="col-2">
                {{localService.languageContent.table.last_avtivity}}
            </div>
            <div class="col-2">
                {{localService.languageContent.table.expire_on}}
            </div>
        </div>
        <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
            <div class="row styled_row freeze_col" *ngFor="let item of wrapper.items">
                <div class="col-md-5">
                    <span>{{item.v1}}</span>
                </div>
                <div class="col-md-3">
                    <span class="en">{{item.v3}}</span>
                </div>
                <div class="col-md-2">
                    <span class="en">{{item.v5 | date : 'dd-MMM-yyyy'}}</span>
                </div>
                <div class="col-md-2">
                    <span class="en">{{item.v2 | date : 'dd-MMM-yyyy'}}</span>
                    <span class="en" style="color: burlywood;">&nbsp;({{item.v4}})</span>
                </div>
            </div>
        </div>
    </div>
    <app-paging *ngIf="wrapper && wrapper.paging" [paging]="wrapper.paging" [IsSimple]="true"
        [IsShowSimpleCalenderRange]="true" [IsSimpleSearchBarReq]="false" (onPagingRefreshed)="onLoad()" />
</div>
<div>
    <span style="display: none;">
        <button class="on_as_country_changed" (click)="onChangeAsCountry()">As Country Changed</button>
    </span>
</div>